import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { EditDialog, Filter, ResourceList, ResourceShow } from '../../../controllers';
import { CurrentVersionField, ImageField, LinkField, TextField } from '../../../fields';
import { BooleanInput, EnumInput, ImageInput, LongTextInput } from '../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <EnumInput
          source="significance"
        />
        <ImageInput
          accept="image/*"
          label="Related pictures"
          source="icon"
        >
          <ImageField
            source="src"
          />
        </ImageInput>
        <BooleanInput
          source="published"
        />
        <LongTextInput
          source="changelog"
        />
      </EditDialog>
    ),  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <LinkField
          source="library_category_id"
          allowEmpty
        />
        <CurrentVersionField />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="id"
        />
        <ImageField
          source="icon"
        />
      </ResourceShow>
    ),

  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
